import { keyframes } from "@emotion/react";

export const shine = keyframes`
	0%, 100% {
		transform: translate(-50%, -50%) rotateZ(0deg);
	}
	50% {
		transform: translate(-50%, -50%) rotateZ(180deg);
	}
`;

export const shineText = keyframes`
	0%, 100% {
		transform: rotateZ(0deg);
	}
	50% {
		transform: rotateZ(180deg);
	}
`;

export const backAndForth = keyframes`
	0%, 100% {
		transform: translateY(10%);
	}
	50% {
		transform: translateY(-10%);
	}
`;

export const sideToSideLeft = keyframes`
	0%, 100% {
		transform: rotate(-90deg) translateY(10%);
	}
	50% {
		transform: rotate(-90deg) translateY(-10%);
	}
`;
